import type { IValidationField } from '../types';
import string from './string';

export default function maxString(field: IValidationField) {
  const { context: { maxLength } = {} } = field;
  return string(field).max(maxLength);
}
